module.exports = __webpack_public_path__ + "static/media/profile.a0889718.svg";